import styled from 'styled-components';

import { COLOR } from '../../../styles/variables';

export const SharingList = styled.ul`
    display: flex;
    justify-content: center;
    align-items: center;
    list-style: none;
    margin: 0 0 0 auto;
    padding: 0;
    line-height: 40px;
    -webkit-tap-highlight-color: rgba(0, 0, 0, 0);
    -webkit-tap-highlight-color: transparent;
    z-index: 9;
    pointer-events: all;
    cursor: pointer;
`;

export const SharingItem = styled.li<{ color?: string; hoverColor?: string }>`
    display: flex;
    align-items: center;
    color: ${({ color }) => color || 'white'};
    margin-right: 1rem;

    &:hover svg {
        shape-rendering: auto;
        color: ${({ hoverColor }) => hoverColor || COLOR.br24.blue};
    }

    a {
        display: flex;
        align-items: center;
        text-decoration: none;
    }
`;
